import API from 'api';
import { HighlightsResponse, StandardThunkAction } from 'types';
import { Action, actionCreator } from 'util/actions';

// Action types
export const LOAD_HIGHLIGHT_ACTIONS_REQUEST = Symbol(
  'loaders/LOAD_HIGHLIGHT_ACTIONS_REQUEST',
);
export const LOAD_HIGHLIGHT_ACTIONS_SUCCESS = Symbol(
  'loaders/LOAD_HIGHLIGHT_ACTIONS_SUCCESS',
);
export const LOAD_HIGHLIGHT_ACTIONS_ERROR = Symbol(
  'loaders/LOAD_HIGHLIGHT_ACTIONS_ERROR',
);
export const CLEAR_HIGHLIGHT_ACTIONS = Symbol(
  'loaders/CLEAR_HIGHLIGHT_ACTIONS',
);

export type LoadHighlightActionsRequestAction = Action<
  typeof LOAD_HIGHLIGHT_ACTIONS_REQUEST,
  null
>;
export type LoadHighlightActionsSuccessAction = Action<
  typeof LOAD_HIGHLIGHT_ACTIONS_SUCCESS,
  HighlightsResponse
>;
export type LoadHighlightActionsErrorAction = Action<
  typeof LOAD_HIGHLIGHT_ACTIONS_ERROR,
  Error
>;
export type ClearHighlightActionsAction = Action<
  typeof CLEAR_HIGHLIGHT_ACTIONS,
  null
>;

// Action creators
const loadHighlightActionsRequest = actionCreator<
  LoadHighlightActionsRequestAction
>(LOAD_HIGHLIGHT_ACTIONS_REQUEST);
const loadHighlightActionsSuccess = actionCreator<
  LoadHighlightActionsSuccessAction
>(LOAD_HIGHLIGHT_ACTIONS_SUCCESS);
const loadHighlightActionsError = actionCreator<
  LoadHighlightActionsErrorAction
>(LOAD_HIGHLIGHT_ACTIONS_ERROR);
export const clearHighlightActions = actionCreator<ClearHighlightActionsAction>(
  CLEAR_HIGHLIGHT_ACTIONS,
);

export const loadHighlightActions = (
  idTeam?: string,
): StandardThunkAction<
  Promise<LoadHighlightActionsSuccessAction | LoadHighlightActionsErrorAction>
> => {
  return async (dispatch, getState) => {
    try {
      dispatch(loadHighlightActionsRequest());

      const highlights = await API.client.rest.get<HighlightsResponse>(
        'members/me/highlights',
        {
          query: {
            board: true,
            board_organization: true,
            card: true,
            display: true,
            entities: true,
            list: true,
            memberCreator: true,
            ...(idTeam ? { organization: idTeam } : {}),
          },
        },
      );

      return dispatch(loadHighlightActionsSuccess(highlights));
    } catch (err) {
      return dispatch(loadHighlightActionsError(err));
    }
  };
};



// WEBPACK FOOTER //
// ./app/gamma/src/modules/loaders/load-highlight-actions.ts